import React, { createContext, useContext, useEffect, useState } from 'react';

// Fail closed until the server explicitly enables a feature.
export const FeatureFlagsContext = createContext({ profitPlannerEnabled: false, gradingQueryEnabled: false, gradingPlusCheckoutEnabled: false, coinMcpEnabled: false, coinMcpPlannerEnabled: false, loading: false });

export function FeatureFlagsProvider({ children }) {
  const [flags, setFlags] = useState({ profitPlannerEnabled: false, gradingQueryEnabled: false, gradingPlusCheckoutEnabled: false, coinMcpEnabled: false, coinMcpPlannerEnabled: false, loading: true });

  useEffect(() => {
    let active = true;
    async function loadFlags() {
      let profitPlannerEnabled = false;
      let gradingQueryEnabled = false;
      let gradingPlusCheckoutEnabled = false;
      let coinMcpEnabled = false;
      let coinMcpPlannerEnabled = false;
      try {
        const response = await fetch('/api/features', { credentials: 'same-origin', cache: 'no-store' });
        if (response.ok) {
          const data = await response.json();
          profitPlannerEnabled = data.profit_planner_enabled === true;
          gradingQueryEnabled = data.grading_query_enabled === true;
          gradingPlusCheckoutEnabled = data.grading_plus_checkout_enabled === true;
          coinMcpEnabled = data.coin_mcp_enabled === true;
          coinMcpPlannerEnabled = data.coin_mcp_planner_enabled === true;
        }
      } catch {
        // Unavailable or invalid configuration keeps unreleased features hidden.
      }
      if (active) setFlags({ profitPlannerEnabled, gradingQueryEnabled, gradingPlusCheckoutEnabled, coinMcpEnabled, coinMcpPlannerEnabled, loading: false });
    }
    loadFlags();
    return () => { active = false; };
  }, []);

  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>;
}

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
